module.exports = __webpack_public_path__ + "img/used.c39cdb81.png";